__turbopack_context__.v({
  "canvas": "editor-module__Jv0z2G__canvas",
  "editor": "editor-module__Jv0z2G__editor",
  "mainContentWrapper": "editor-module__Jv0z2G__mainContentWrapper",
  "mainSplitter": "editor-module__Jv0z2G__mainSplitter",
  "nodeManager": "editor-module__Jv0z2G__nodeManager",
  "renderStats": "editor-module__Jv0z2G__renderStats",
  "splitterCanvas": "editor-module__Jv0z2G__splitterCanvas",
});
